import React, { createContext, useContext, useState } from 'react';

interface AudioContextType {
  playingAudioId: string | null;
  setPlayingAudioId: (id: string | null) => void;
  triggerPlayId: string | null;
  setTriggerPlayId: (id: string | null) => void;
}

const AudioContext = createContext<AudioContextType | undefined>(undefined);

interface AudioProviderProps {
  children: React.ReactNode;
}

export const AudioProvider: React.FC<AudioProviderProps> = ({ children }) => {
  const [playingAudioId, setPlayingAudioId] = useState<string | null>(null);
  const [triggerPlayId, setTriggerPlayId] = useState<string | null>(null);
  return (
    <AudioContext.Provider value={{ playingAudioId, setPlayingAudioId , triggerPlayId, setTriggerPlayId }}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudioContext = (): AudioContextType => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudioContext must be used within an AudioProvider');
  }
  return context;
};